/**
 * Stands in for a missing blog or shop image: the first letter of the label
 * on the brand gradient. Fills its parent, so the parent sets the box, and the
 * letter scales with the box's width.
 */
export function ImageFallback({ label }: { label: string }) {
	return (
		<div
			className="bg-gradient-brand text-brand-foreground @container flex h-full w-full items-center justify-center select-none"
			aria-hidden="true"
		>
			<span className="text-[15cqw] leading-none font-bold">
				{label.charAt(0).toUpperCase()}
			</span>
		</div>
	)
}
